'use strict'

export default function CutCrewImpactSummary ({ cutRoute, displaced, suggestedMovesCount, unassignedCount, warnings }) {
  const cards = [
    { label: 'Displaced', value: displaced?.propertyCount || 0 },
    { label: 'Reassigned', value: suggestedMovesCount || 0, color: '#2f7a3e' },
    { label: 'Unassigned', value: unassignedCount || 0, color: unassignedCount > 0 ? '#a9341d' : undefined },
    { label: 'VIP Affected', value: displaced?.vipCount || 0, color: displaced?.vipCount > 0 ? '#a4502f' : undefined },
    { label: 'Locked (cut crew)', value: displaced?.lockedToCutCrewCount || 0 },
    { label: 'Weekly Minutes', value: displaced?.weeklyServiceMinutes || 0 }
  ]

  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--df-ink, #1c2419)' }}>
          Cutting: {cutRoute?.routeName || 'Unknown'}
        </span>
        <span style={{ fontSize: 13, color: 'var(--df-ink-3, #6f7a6b)', marginLeft: 8 }}>
          {cutRoute?.crewName || 'Unknown'}
        </span>
      </div>

      {warnings && warnings.length > 0 && warnings.map((w, i) => (
        <div key={i} style={{
          padding: '8px 12px', borderRadius: 8, marginBottom: 8,
          background: '#fbe8d6', color: '#a4502f', fontSize: 12, fontWeight: 600
        }}>
          {w}
        </div>
      ))}

      <div style={{
        display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 16
      }}>
        {cards.map(card => (
          <div key={card.label} style={{
            flex: '1 1 120px', minWidth: 100, padding: '12px 14px', textAlign: 'center',
            borderRadius: 10, border: '1px solid var(--df-line, #e0d8c2)',
            background: 'var(--df-surface, #fbf8f1)'
          }}>
            <div style={{
              fontSize: '1.5rem', fontWeight: 700,
              color: card.color || 'var(--df-ink, #1c2419)'
            }}>
              {card.value}
            </div>
            <div style={{
              fontSize: 11, fontWeight: 600, color: 'var(--df-ink-4, #97a094)', marginTop: 2,
              textTransform: 'uppercase', letterSpacing: '0.04em'
            }}>
              {card.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
